/* ══════════════════════════════════════════════════════════════════
   KO Reviews — arma la sección de reseñas reales a partir del JSON
   que Judge.me mantiene por producto (product.metafields.judgeme
   .review_widget_data), emitido por snippets/ko-reviews.liquid como
   <script type="application/json" data-ko-rv-src>.
   Modo "product": reseñas de UN producto (PDP) + badge del panel.
   Modo "home": reseñas de toda la tienda (ko-testimonials).
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var STAR = '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M10 1.3l2.6 5.6 6.1.7-4.5 4.2 1.2 6.1L10 14.9 4.6 17.9l1.2-6.1L1.3 7.6l6.1-.7z"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
  var X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>';
  var PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
  var NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>';
  var MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function stars(n, cls) {
    var out = '<span class="ko-rv__stars ' + (cls || '') + '" aria-label="' + n + ' de 5 estrellas">';
    for (var i = 1; i <= 5; i++) out += '<span class="' + (i <= Math.round(n) ? '' : 'is-off') + '">' + STAR + '</span>';
    return out + '</span>';
  }
  function plural(n, s, p) { return n + ' ' + (n === 1 ? s : p); }
  function relDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d)) return '';
    var days = Math.floor((Date.now() - d.getTime()) / 864e5);
    if (days < 1) return 'hoy';
    if (days < 7) return 'hace ' + plural(days, 'día', 'días');
    if (days < 30) return 'hace ' + plural(Math.round(days / 7), 'semana', 'semanas');
    if (days < 365) return 'hace ' + plural(Math.round(days / 30), 'mes', 'meses');
    return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  }
  function isoDate(iso) { var d = new Date(iso); return isNaN(d) ? '' : d.toISOString().slice(0, 10); }
  function img(url, w) {
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ── Lee y normaliza todas las fuentes de la sección ── */
  function collect(root) {
    var out = [], srcs = root.querySelectorAll('[data-ko-rv-src]');
    Array.prototype.forEach.call(srcs, function (tag) {
      var data;
      try { data = JSON.parse(tag.textContent); } catch (e) { return; }
      if (!data) return;
      var pTitle = tag.getAttribute('data-product-title') || data.product_name || '';
      var pUrl = tag.getAttribute('data-product-url') || '';
      var pImg = tag.getAttribute('data-product-image') || data.image_url || '';
      (data.reviews || []).forEach(function (r) {
        if (!r || !(r.rating >= 1)) return;
        var body = (r.body || '').trim();
        if (!body && !(r.pictures_urls && r.pictures_urls.length)) return;
        var pics = (r.pictures_urls || []).map(function (p) {
          return { thumb: img(p.small || p.compact || p.original, 320), card: img(p.original || p.huge, 900), full: p.huge || p.original };
        });
        out.push({
          id: r.uuid || (pTitle + r.created_at),
          name: (r.reviewer_name || 'Cliente').trim(),
          initial: (r.reviewer_initial || (r.reviewer_name || 'C').charAt(0)).toUpperCase(),
          rating: Math.max(1, Math.min(5, Math.round(r.rating))),
          title: (r.title || '').trim(),
          body: body,
          verified: !!r.verified_buyer,
          date: r.created_at || '',
          pinned: !!r.pinned,
          pics: pics,
          reply: (r.reply_content || '').trim(),
          replyName: r.shop_reply_name || 'Keycaps Office',
          product: pTitle,
          url: pUrl,
          pimg: r.product_variant_image_url || pImg,
          variant: r.product_variant_title || ''
        });
      });
    });
    return out;
  }

  function sortReviews(list) {
    return list.slice().sort(function (a, b) {
      if (a.pinned !== b.pinned) return a.pinned ? -1 : 1;
      var ap = a.pics.length ? 1 : 0, bp = b.pics.length ? 1 : 0;
      if (ap !== bp) return bp - ap;
      return (b.date > a.date) ? 1 : (b.date < a.date ? -1 : 0);
    });
  }

  /* ── Pieza del muro: foto (imagen completa + texto encima) o nota de texto ── */
  function prodChip(r, mode) {
    if (mode !== 'home' || !r.product) return '';
    var tag = r.url ? 'a' : 'span';
    return '<' + tag + ' class="ko-rv__prod"' + (r.url ? ' href="' + escapeHtml(r.url) + '"' : '') + '>Sobre <b>' + escapeHtml(r.product) + '</b>' + (r.url ? ' →' : '') + '</' + tag + '>';
  }
  function card(r, mode, onZoom, size) {
    var c = el('article', 'ko-rv__card ' + (r.pics.length ? 'ko-rv__card--photo' : 'ko-rv__card--text') + (size ? ' ko-rv__card--' + size : ''));
    c.setAttribute('data-rating', r.rating);
    var who = '<span class="ko-rv__vf' + (r.verified ? ' is-verified' : '') + '">' + (r.verified ? CHECK + 'Verificada' : 'Reseña real') + '</span>';
    var h = '';
    if (r.pics.length) {
      h += '<button type="button" class="ko-rv__media" aria-label="Ver foto y reseña de ' + escapeHtml(r.name) + '">'
        + '<img src="' + escapeHtml(r.pics[0].card) + '" alt="Foto de cliente: ' + escapeHtml(r.product || 'keycap') + '" loading="lazy" decoding="async"></button>'
        + (r.pics.length > 1 ? '<span class="ko-rv__media-n">+' + (r.pics.length - 1) + ' fotos</span>' : '')
        + '<div class="ko-rv__over">' + stars(r.rating)
        + (r.body ? '<p class="ko-rv__over-q">' + escapeHtml(r.body) + '</p>' : '')
        + '<div class="ko-rv__over-w"><b>' + escapeHtml(r.name) + '</b>' + (r.date ? '<span>· ' + relDate(r.date) + '</span>' : '') + who + '</div>'
        + (mode === 'home' && r.product ? '<span class="ko-rv__prod">Sobre <b>' + escapeHtml(r.product) + '</b></span>' : '')
        + '</div>';
      c.innerHTML = h;
      c.addEventListener('click', function (e) {
        var link = e.target.closest('a'); if (link) return;
        onZoom(r, 0);
      });
      return c;
    }
    h += '<div class="ko-rv__top">' + stars(r.rating, 'ko-rv__stars--sm') + (r.date ? '<time class="ko-rv__date" datetime="' + escapeHtml(isoDate(r.date)) + '">' + relDate(r.date) + '</time>' : '') + '</div>'
      + (r.title ? '<h3 class="ko-rv__ttl">' + escapeHtml(r.title) + '</h3>' : '')
      + (r.body ? '<p class="ko-rv__txt' + (r.body.length > 150 ? ' is-clamped' : '') + '">' + escapeHtml(r.body) + '</p>' : '')
      + (r.body.length > 150 ? '<button type="button" class="ko-rv__more-t" aria-expanded="false">Leer más</button>' : '')
      + (r.reply ? '<div class="ko-rv__reply"><b>Respuesta de ' + escapeHtml(r.replyName) + '</b>' + escapeHtml(r.reply) + '</div>' : '')
      + '<div class="ko-rv__who"><span class="ko-rv__av" aria-hidden="true">' + escapeHtml(r.initial) + '</span>'
      + '<div class="ko-rv__who-t"><span class="ko-rv__name">' + escapeHtml(r.name) + '</span>' + who + '</div></div>'
      + prodChip(r, mode);
    c.innerHTML = h;
    var more = c.querySelector('.ko-rv__more-t');
    if (more) {
      more.addEventListener('click', function () {
        var p = c.querySelector('.ko-rv__txt');
        var open = p.classList.toggle('is-clamped') === false;
        c.classList.toggle('is-open', open);
        more.textContent = open ? 'Leer menos' : 'Leer más';
        more.setAttribute('aria-expanded', String(open));
      });
    }
    return c;
  }

  /* Tamaño de cada pieza: fotos alternan grande (2x2) y normal (1x1);
     notas largas van anchas (2x1). El grid denso rellena los huecos. */
  function sizeFor(r, i, photoIdx) {
    if (r.pics.length) return photoIdx % 3 === 0 ? 'big' : (photoIdx % 3 === 2 && r.body.length > 90 ? 'wide' : '');
    return r.body.length > 120 || r.reply ? 'wide' : '';
  }

  /* ── Lightbox ── */
  function lightbox(root, photos) {
    var lb = root.querySelector('[data-ko-rv-lb]');
    if (!lb) return function () {};
    lb.innerHTML = '<button type="button" class="ko-rv__lb-x" aria-label="Cerrar">' + X + '</button>'
      + '<span class="ko-rv__lb-c" data-c></span>'
      + '<button type="button" class="ko-rv__lb-p" aria-label="Anterior">' + PREV + '</button>'
      + '<button type="button" class="ko-rv__lb-n" aria-label="Siguiente">' + NEXT + '</button>'
      + '<figure class="ko-rv__lb-fig"><img class="ko-rv__lb-img" alt=""><figcaption class="ko-rv__lb-cap" data-cap></figcaption></figure>';
    var imgEl = lb.querySelector('img'), cap = lb.querySelector('[data-cap]'), cnt = lb.querySelector('[data-c]');
    var idx = 0, lastFocus = null;
    function show(i) {
      if (!photos.length) return;
      idx = (i + photos.length) % photos.length;
      var p = photos[idx];
      imgEl.src = p.full; imgEl.alt = 'Foto de ' + p.r.name + (p.r.product ? ' — ' + p.r.product : '');
      cap.innerHTML = '<div class="ko-rv__lb-cap-h">' + stars(p.r.rating) + '<b>' + escapeHtml(p.r.name) + '</b>' + (p.r.product ? '<span style="color:var(--rv-muted);font-size:12px">· ' + escapeHtml(p.r.product) + '</span>' : '') + '</div>' + (p.r.body ? '<p>' + escapeHtml(p.r.body) + '</p>' : '');
      cnt.textContent = (idx + 1) + ' / ' + photos.length;
      var nx = photos[(idx + 1) % photos.length]; if (nx) { var pre = new Image(); pre.src = nx.full; }
    }
    function open(i) {
      lastFocus = document.activeElement;
      lb.hidden = false; document.body.classList.add('ko-rv-lock');
      show(i);
      requestAnimationFrame(function () { lb.classList.add('is-open'); lb.querySelector('.ko-rv__lb-x').focus(); });
      document.addEventListener('keydown', onKey);
    }
    function close() {
      lb.classList.remove('is-open'); document.body.classList.remove('ko-rv-lock');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { lb.hidden = true; imgEl.src = ''; }, reduced ? 0 : 220);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'ArrowLeft') show(idx - 1);
    }
    lb.querySelector('.ko-rv__lb-x').addEventListener('click', close);
    lb.querySelector('.ko-rv__lb-p').addEventListener('click', function () { show(idx - 1); });
    lb.querySelector('.ko-rv__lb-n').addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    var tx = null;
    lb.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (tx == null) return;
      var dx = e.changedTouches[0].clientX - tx; tx = null;
      if (Math.abs(dx) > 40) show(dx < 0 ? idx + 1 : idx - 1);
    }, { passive: true });
    if (photos.length < 2) { lb.querySelector('.ko-rv__lb-p').hidden = true; lb.querySelector('.ko-rv__lb-n').hidden = true; }
    return open;
  }

  function reveal(cards) {
    if (reduced || !('IntersectionObserver' in window)) { cards.forEach(function (c) { c.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
    cards.forEach(function (c, i) { c.style.transitionDelay = ((i % 3) * 70) + 'ms'; io.observe(c); });
  }

  /* ── Sección ── */
  function init(root) {
    if (root.dataset.koRvReady) return;
    root.dataset.koRvReady = '1';
    var mode = root.getAttribute('data-ko-reviews-mode') || 'product';
    root.classList.add('ko-rv--' + mode);
    var all = sortReviews(collect(root));
    var grid = root.querySelector('[data-ko-rv-grid]');
    var summary = root.querySelector('[data-ko-rv-summary]');
    var empty = root.querySelector('[data-ko-rv-empty]');
    var photosWrap = root.querySelector('[data-ko-rv-photos]');
    var moreBtn = root.querySelector('[data-ko-rv-more]');
    var fallback = document.querySelector('[data-ko-rv-fallback]');
    var limit = parseInt(root.getAttribute('data-ko-rv-limit') || '9', 10);

    if (!all.length) {
      if (empty) empty.hidden = false;
      if (summary) summary.hidden = true;
      if (fallback) fallback.hidden = false;
      root.classList.add('is-empty');
      return;
    }
    if (fallback) fallback.hidden = true;

    /* Fotos (para el lightbox; en el muro cada foto aparece UNA vez) */
    var photos = [];
    all.forEach(function (r) { r.pics.forEach(function (p, i) { photos.push({ r: r, i: i, thumb: p.thumb, full: p.full }); }); });

    /* Resumen */
    var n = all.length, sum = 0, hist = [0, 0, 0, 0, 0, 0], rec = 0;
    all.forEach(function (r) { sum += r.rating; hist[r.rating]++; if (r.rating >= 4) rec++; });
    var avg = sum / n;
    if (summary) {
      summary.hidden = false;
      var avgEl = summary.querySelector('[data-ko-rv-avg]'); if (avgEl) avgEl.innerHTML = avg.toFixed(1).replace('.', ',') + '<small>/ 5</small>';
      var stEl = summary.querySelector('[data-ko-rv-stars]'); if (stEl) stEl.innerHTML = stars(avg);
      var cEl = summary.querySelector('[data-ko-rv-count]');
      if (cEl) cEl.innerHTML = '<b>' + plural(n, 'reseña', 'reseñas') + '</b> · ' + Math.round(rec / n * 100) + '% recomienda' + (photos.length ? ' · ' + plural(photos.length, 'foto', 'fotos') : '');
      var bars = summary.querySelector('[data-ko-rv-bars]');
      if (bars) {
        bars.innerHTML = '';
        for (var s = 5; s >= 1; s--) {
          var b = el('button', 'ko-rv__bar', '<span>' + s + '★</span><i></i><span>' + hist[s] + '</span>');
          b.type = 'button'; b.setAttribute('data-star', s); b.setAttribute('aria-label', 'Filtrar ' + s + ' estrellas (' + hist[s] + ')');
          if (!hist[s]) b.disabled = true;
          (function (pct, bar) { requestAnimationFrame(function () { setTimeout(function () { bar.querySelector('i').style.setProperty('--w', pct + '%'); }, 120); }); })(Math.round(hist[s] / n * 100), b);
          bars.appendChild(b);
        }
      }
    }

    var openLb = lightbox(root, photos);
    function zoom(r, i) {
      for (var k = 0; k < photos.length; k++) if (photos[k].r === r && photos[k].i === i) { openLb(k); return; }
    }
    if (photosWrap) photosWrap.hidden = true;

    /* Muro: mezcla fotos y notas para que no queden todas las fotos juntas */
    var withPic = all.filter(function (r) { return r.pics.length; }), noPic = all.filter(function (r) { return !r.pics.length; });
    var mixed = [], pi = 0, ti = 0;
    while (pi < withPic.length || ti < noPic.length) {
      if (pi < withPic.length) mixed.push(withPic[pi++]);
      for (var k = 0; k < 2 && ti < noPic.length; k++) mixed.push(noPic[ti++]);
    }
    var photoIdx = 0;
    var cards = mixed.map(function (r, i) { var sz = sizeFor(r, i, photoIdx); if (r.pics.length) photoIdx++; return card(r, mode, zoom, sz); });
    cards.forEach(function (c) { grid.appendChild(c); });
    if (moreBtn) moreBtn.hidden = true;
    var active = 0;

    /* El muro llena EXACTAMENTE N filas (3 desktop / 4 mobile): se muestran las
       piezas que caben, las grandes se achican si no hay espacio y, si el grid
       se pasa de alto por el empaquetado, se demota/oculta la última pieza. */
    function wallCols() { var w = window.innerWidth; return w <= 749 ? 2 : (w <= 1000 ? 3 : 4); }
    function cellsOf(c) { return c.classList.contains('ko-rv__card--big') ? 4 : (c.classList.contains('ko-rv__card--wide') ? 2 : 1); }
    function demote(c) { c.classList.remove('ko-rv__card--big', 'ko-rv__card--wide'); }
    var sizeOrig = cards.map(function (c) { return c.className; });
    function fitWall() {
      if (active) return;
      var cols = wallCols(), rows = 3, cap = cols * rows, used = 0;
      cards.forEach(function (c, i) {
        c.className = sizeOrig[i]; c.classList.add('is-in');
        var k = cellsOf(c);
        if (used + k <= cap) { used += k; c.classList.remove('is-hidden'); }
        else if (used + 1 <= cap) { demote(c); used += 1; c.classList.remove('is-hidden'); }
        else c.classList.add('is-hidden');
      });
      var cs = getComputedStyle(grid), row = parseFloat(cs.gridAutoRows) || 168, gap = parseFloat(cs.rowGap) || 12;
      var pad = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
      var maxH = rows * row + (rows - 1) * gap + pad + 2, guard = 0;
      while (grid.getBoundingClientRect().height > maxH && guard++ < 40) {
        var shown = cards.filter(function (c) { return !c.classList.contains('is-hidden'); });
        var last = null;
        for (var j = shown.length - 1; j >= 0; j--) if (cellsOf(shown[j]) > 1) { last = shown[j]; break; }
        if (last) demote(last); else if (shown.length) shown[shown.length - 1].classList.add('is-hidden'); else break;
      }
    }
    fitWall();
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fitWall, 120); });

    /* Filtro por estrellas (click en barra) */
    root.addEventListener('click', function (e) {
      var bar = e.target.closest('.ko-rv__bar');
      if (!bar || !root.contains(bar)) return;
      var s = parseInt(bar.getAttribute('data-star'), 10);
      active = active === s ? 0 : s;
      Array.prototype.forEach.call(root.querySelectorAll('.ko-rv__bar'), function (b) { b.classList.toggle('is-on', parseInt(b.getAttribute('data-star'), 10) === active); });
      cards.forEach(function (c, i) {
        var show = !active || parseInt(c.getAttribute('data-rating'), 10) === active;
        c.classList.toggle('is-filtered', !show);
        if (active && show) { c.className = sizeOrig[i]; c.classList.add('is-in'); c.classList.remove('is-hidden'); }
      });
      if (!active) fitWall();
    });


    /* Escribir reseña: revela el widget de Judge.me y dispara su formulario */
    var write = root.querySelector('[data-ko-rv-write]');
    if (write) write.addEventListener('click', function () { openWriteForm(); });

    /* Badge del panel del PDP */
    if (mode === 'product') {
      Array.prototype.forEach.call(document.querySelectorAll('[data-ko-rating]'), function (a) {
        a.innerHTML = stars(avg) + '<b>' + avg.toFixed(1).replace('.', ',') + '</b><u>' + plural(n, 'reseña', 'reseñas') + '</u>';
        a.hidden = false;
        a.addEventListener('click', function (e) {
          e.preventDefault();
          root.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        });
      });
    }
  }

  function openWriteForm() {
    var wrap = document.querySelector('[data-ko-jdgm-wrap]');
    if (!wrap) return;
    wrap.hidden = false;
    wrap.classList.add('is-open');
    var tries = 0;
    (function poke() {
      var link = wrap.querySelector('.jdgm-write-rev-link');
      if (link) {
        try { link.click(); } catch (e) {}
        setTimeout(function () { (wrap.querySelector('.jdgm-form') || wrap).scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); }, 150);
      } else if (tries++ < 20) setTimeout(poke, 250);
      else wrap.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    })();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ko-reviews]'), init);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ko-rv-write-empty]'), function (b) {
      b.addEventListener('click', openWriteForm);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.koReviews = { init: init, openWriteForm: openWriteForm };
})();
